import React from "react";
import { isEqual } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { socket } from "../../../../lib/socketio";
import { GroupTemplate } from "../../../Definitions/cl";
import { Grid, Segment } from "semantic-ui-react";
import Footer from "../../Footer";
import {
  CLD_open,
  CLD_close,
  PSMStack,
} from "../../../Definitions/GraphicComponents";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { setUser } from "../../../../actions/navActions";

const StackOvr_S300_PSM2 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  const prevVoltObj = React.useRef();
  const prevTempObj = React.useRef();

  const maxTemp = React.useRef(-99999);
  const minTemp = React.useRef(99999);
  const maxVolt = React.useRef(-99999);
  const minVolt = React.useRef(99999);

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 273 }, { display_id: 128 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) =>
    // t.page_name === 'Footer_PSM1' ? [t] : []);
    t.display_id === 128 ? [t] : [],
  );

  const GenTags = tags.flatMap((t) => (t.display_id === 273 ? [t] : []));

  const display = GenTags.map((t) => t.page_name);

  const StackTags = GroupTemplate(GenTags, "tag_display_subgroup");

  const tempIds = tags.flatMap((t) =>
    t.tag_display_subgroup === "TEMP" ? [t.id] : [],
  );
  const voltIds = tags.flatMap((t) =>
    t.tag_display_subgroup === "VOLTAGE" ? [t.id] : [],
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });
    }
  }, [ids, data]);

  const getPropById = (ids, property) => {
    // id로 원하는 value 가져오는 함수
    let objArray = Object.values(tags).filter((c) => c.id === ids);
    return objArray[0][property];
  };

  let voltObj = [];
  let tempObj = [];

  if (voltIds.length > 0 && voltObj.length === 0) {
    for (let i = 0; i < voltIds.length; i++) {
      let stackId = getPropById(voltIds[i], "hmi_controlloop_subdisplay");
      voltObj.push({
        ids: voltIds[i],
        value: data[voltIds[i]],
        status: "def",
        stackId: stackId,
        subgroup: "VOLT",
      });
    }
  }

  if (tempIds.length > 0 && tempObj.length === 0) {
    for (let i = 0; i < tempIds.length; i++) {
      let stackId = getPropById(tempIds[i], "hmi_controlloop_subdisplay");
      tempObj.push({
        ids: tempIds[i],
        value: data[tempIds[i]],
        status: "def",
        stackId: stackId,
        subgroup: "TEMP",
      });
    }
  }

  // ^ getMaxTemp, getMinTemp 생성완료
  const getMaxTempValue = (obj) => {
    // update 240826, min/max temp limit
    obj = Object.values(obj).filter((c) => c.value > -31 && c.value < 701);
    maxTemp.current = Math.max(...Object.values(obj).map((c) => c.value));
    return maxTemp;
  };

  const getMinTempValue = (obj) => {
    // update 240826, min/max temp limit
    obj = Object.values(obj).filter((c) => c.value > -31 && c.value < 701);
    minTemp.current = Math.min(...Object.values(obj).map((c) => c.value));
    return minTemp;
  };

  const getMaxVoltValue = (obj) => {
    maxVolt.current = Math.max(...Object.values(obj).map((c) => c.value));
    return maxVolt;
  };

  const getMinVoltValue = (obj) => {
    minVolt.current = Math.min(...Object.values(obj).map((c) => c.value));
    return minVolt;
  };

  // ^ tempObj 변경시에만 실행됨
  React.useEffect(() => {
    if (tempObj && !isEqual(tempObj, prevTempObj.current)) {
      prevTempObj.current = tempObj;
      getMaxTempValue(tempObj);
      getMinTempValue(tempObj);
      changeStatusValue(tempObj);
    }
    if (voltObj && !isEqual(voltObj, prevVoltObj.current)) {
      prevVoltObj.current = voltObj;
      // changeStatusValue(getMaxVoltValue(voltObj), getMinVoltValue(voltObj), voltObj);
      getMaxVoltValue(voltObj);
      getMinVoltValue(voltObj);
      changeStatusValue(voltObj);
    }
  }, [tempObj, voltObj]);

  // ^ obj를 받고, obj의 value 값 중에 max보다 크거나 같은 값이 있으면 status를 max로 변경함
  const changeStatusValue = (obj) => {
    if (obj.length > 0 && Object.values(obj)[0].subgroup === "VOLT") {
      Object.values(obj).map((c) =>
        c.value >= maxVolt.current
          ? (c.status = "max")
          : c.value <= minVolt.current
            ? (c.status = "min")
            : "",
      );
    } else if (obj.length > 0 && Object.values(obj)[0].subgroup === "TEMP") {
      Object.values(obj).map((c) =>
        c.value >= maxTemp.current
          ? (c.status = "max")
          : c.value <= minTemp.current
            ? (c.status = "min")
            : "",
      );
    }
  };

  const colorByRange = (ids, obj) => {
    let objArr;
    let currentStatus;
    let color;

    // update 240826, min/max temp limit
    obj = Object.values(obj).filter((c) => c.value > -31 && c.value < 701);

    if (obj.length > 0 && typeof obj !== "undefined") {
      if (Object.values(obj)[0].subgroup === "TEMP") {
        getMaxTempValue(obj);
        getMinTempValue(obj);
      } else if (Object.values(obj)[0].subgroup === "VOLT") {
        getMaxVoltValue(obj);
        getMinVoltValue(obj);
      }
    }

    changeStatusValue(obj);

    if (obj.length > 0) {
      objArr = Object.values(obj).filter((c) => c.ids === ids);
      if (objArr.length > 0) {
        currentStatus = objArr[0].status;
        if (currentStatus === "min") {
          color = "#FC262D";
        } else if (currentStatus === "max") {
          color = "#33FF33";
        } else {
          color = "white";
        }
      }
    }
    return color;
  };

  const getDisplayMinValue = (obj) => {
    if (obj.length > 0 && typeof obj !== "undefined") {
      if (Object.values(obj)[0].subgroup === "TEMP") {
        // update 240826, min/max temp limit
        obj = Object.values(obj).filter((c) => c.value > -31 && c.value < 701);

        getMinTempValue(obj);

        let minStackObj = Object.values(obj).filter((c) => c.status === "min");
        let minStackArr = Object.values(minStackObj).map((c) => c.stackId);

        if (minStackArr.length > 1) {
          let arr = minStackArr.join(" , ");
          return arr;
        } else {
          return minStackArr;
        }
      } else if (Object.values(obj)[0].subgroup === "VOLT") {
        getMinVoltValue(obj);

        let minStackObj = Object.values(obj).filter((c) => c.status === "min");
        let minStackArr = Object.values(minStackObj).map((c) => c.stackId);

        if (minStackArr.length > 1) {
          let arr = minStackArr.join(" , ");
          return arr;
        } else {
          return minStackArr;
        }
      }
    }
  };

  const getDisplayMaxValue = (obj) => {
    if (obj.length > 0 && typeof obj !== "undefined") {
      if (Object.values(obj)[0].subgroup === "TEMP") {
        // update 240826, min/max temp limit
        obj = Object.values(obj).filter((c) => c.value > -31 && c.value < 701);

        getMaxTempValue(obj);

        let maxStackObj = Object.values(obj).filter((c) => c.status === "max");
        let maxStackArr = Object.values(maxStackObj).map((c) => c.stackId);

        if (maxStackArr.length > 1) {
          let arr = maxStackArr.join(" , ");
          return arr;
        } else {
          return maxStackArr;
        }
      } else if (Object.values(obj)[0].subgroup === "VOLT") {
        getMaxVoltValue(obj);

        let maxStackObj = Object.values(obj).filter((c) => c.status === "max");
        let maxStackArr = Object.values(maxStackObj).map((c) => c.stackId);

        if (maxStackArr.length > 1) {
          let arr = maxStackArr.join(" , ");
          return arr;
        } else {
          return maxStackArr;
        }
      }
    }
  };

  // update 241029, display CLD
  const gridCLD = (tag_id) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        <Grid.Column width={8} style={styles.name}>
          {typeof data !== "undefined" &&
          data !== null &&
          typeof data[tag_id] !== "undefined"
            ? data[tag_id] === 0
              ? "ON"
              : "OFF"
            : ""}
        </Grid.Column>
        <Grid.Column style={styles.unit}>
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tag_id === 6273 || tag_id === 6280
              ? "SP"
              : tags[tags.findIndex((x) => x.id === tag_id)].unit
            : ""}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px", marginTop: "0px" }}>
        <Grid.Column
          style={{
            color: "yellow",
            fontSize: "15px",
            fontWeight: "bold",
            marginLeft: "10px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
            : ""}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]} </h1>

      <svg width="2000" height="440">
        {data[275120] === 0 ? (
          <CLD_open rect={{ x: 700, y: 25 }} />
        ) : (
          <CLD_close rect={{ x: 700, y: 25 }} />
        )}
        {data[275160] === 0 ? (
          <CLD_open rect={{ x: 1000, y: 25 }} />
        ) : (
          <CLD_close rect={{ x: 1000, y: 25 }} />
        )}
        {data[275200] === 0 ? (
          <CLD_open rect={{ x: 1300, y: 25 }} />
        ) : (
          <CLD_close rect={{ x: 1300, y: 25 }} />
        )}
        <PSMStack
          id="Stack A1"
          rect={{ x: 640, y: 105 }}
          color="#404040"
          text1="Stack A1"
          temp={data[11770]}
          volt={
            typeof data !== "undefined" &&
            data[13468] !== null &&
            typeof data[13468] !== "undefined"
              ? data[13468].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11770, tempObj)}
          voltColor={colorByRange(13468, voltObj)}
        />{" "}
        {/* Stack A1 , text2에 온도, text3에 voltage값 */}
        <PSMStack
          id="Stack A2"
          rect={{ x: 640, y: 185 }}
          color="#404040"
          text1="Stack A2"
          temp={data[11784]}
          volt={
            typeof data !== "undefined" &&
            data[13469] !== null &&
            typeof data[13469] !== "undefined"
              ? data[13469].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11784, tempObj)}
          voltColor={colorByRange(13469, voltObj)}
        />{" "}
        {/* Stack A2*/}
        <PSMStack
          id="Stack A3"
          rect={{ x: 640, y: 265 }}
          color="#404040"
          text1="Stack A3"
          temp={data[11791]}
          volt={
            typeof data !== "undefined" &&
            data[13470] !== null &&
            typeof data[13470] !== "undefined"
              ? data[13470].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11791, tempObj)}
          voltColor={colorByRange(13470, voltObj)}
        />{" "}
        {/* Stack A3 */}
        <PSMStack
          id="Stack A4"
          rect={{ x: 640, y: 345 }}
          color="#404040"
          text1="Stack A4"
          temp={data[11756]}
          volt={
            typeof data !== "undefined" &&
            data[13471] !== null &&
            typeof data[13471] !== "undefined"
              ? data[13471].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11756, tempObj)}
          voltColor={colorByRange(13471, voltObj)}
        />{" "}
        {/* Stack A4 */}
        <PSMStack
          id="Stack B1"
          rect={{ x: 940, y: 105 }}
          color="#404040"
          text1="Stack B1"
          temp={data[11763]}
          volt={
            typeof data !== "undefined" &&
            data[13472] !== null &&
            typeof data[13472] !== "undefined"
              ? data[13472].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11763, tempObj)}
          voltColor={colorByRange(13472, voltObj)}
        />{" "}
        {/* Stack B1 */}
        <PSMStack
          id="Stack B2"
          rect={{ x: 940, y: 185 }}
          color="#404040"
          text1="Stack B2"
          temp={data[11735]}
          volt={
            typeof data !== "undefined" &&
            data[13473] !== null &&
            typeof data[13473] !== "undefined"
              ? data[13473].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11735, tempObj)}
          voltColor={colorByRange(13473, voltObj)}
        />{" "}
        {/* Stack B2 */}
        <PSMStack
          id="Stack B3"
          rect={{ x: 940, y: 265 }}
          color="#404040"
          text1="Stack B3"
          temp={data[11777]}
          volt={
            typeof data !== "undefined" &&
            data[13474] !== null &&
            typeof data[13474] !== "undefined"
              ? data[13474].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11777, tempObj)}
          voltColor={colorByRange(13474, voltObj)}
        />{" "}
        {/* Stack B3 */}
        <PSMStack
          id="Stack B4"
          rect={{ x: 940, y: 345 }}
          color="#404040"
          text1="Stack B4"
          temp={data[11742]}
          volt={
            typeof data !== "undefined" &&
            data[13475] !== null &&
            typeof data[13475] !== "undefined"
              ? data[13475].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11742, tempObj)}
          voltColor={colorByRange(13475, voltObj)}
        />{" "}
        {/* Stack B4 */}
        <PSMStack
          id="Stack C1"
          rect={{ x: 1240, y: 105 }}
          color="#404040"
          text1="Stack C1"
          temp={data[11749]}
          volt={
            typeof data !== "undefined" &&
            data[13476] !== null &&
            typeof data[13476] !== "undefined"
              ? data[13476].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11749, tempObj)}
          voltColor={colorByRange(13476, voltObj)}
        />{" "}
        {/* Stack C1 */}
        <PSMStack
          id="Stack C2"
          rect={{ x: 1240, y: 185 }}
          color="#404040"
          text1="Stack C2"
          temp={data[11798]}
          volt={
            typeof data !== "undefined" &&
            data[13477] !== null &&
            typeof data[13477] !== "undefined"
              ? data[13477].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11798, tempObj)}
          voltColor={colorByRange(13477, voltObj)}
        />{" "}
        {/* Stack C2 */}
        <PSMStack
          id="Stack C3"
          rect={{ x: 1240, y: 265 }}
          color="#404040"
          text1="Stack C3"
          temp={data[11805]}
          volt={
            typeof data !== "undefined" &&
            data[13478] !== null &&
            typeof data[13478] !== "undefined"
              ? data[13478].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11805, tempObj)}
          voltColor={colorByRange(13478, voltObj)}
        />{" "}
        {/* Stack C3 */}
        <PSMStack
          id="Stack C4"
          rect={{ x: 1240, y: 345 }}
          color="#404040"
          text1="Stack C4"
          temp={data[11812]}
          volt={
            typeof data !== "undefined" &&
            data[13479] !== null &&
            typeof data[13479] !== "undefined"
              ? data[13479].toFixed(3)
              : ""
          }
          tempColor={colorByRange(11812, tempObj)}
          voltColor={colorByRange(13479, voltObj)}
        />{" "}
        {/* Stack C4 */}
        <path
          d="M 700, 5 L 1300, 5"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* top */}
        <path
          d="M 700, 5 L 700, 25"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* top to CLD1 */}
        <path
          d="M 700, 90 L 700, 105"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* CLD1 to Stack 1 */}
        <path
          d="M 700, 175 L 700, 185"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack1 to stack2 */}
        <path
          d="M 700, 255 L 700, 265"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack2 to stack3 */}
        <path
          d="M 700, 335 L 700, 345"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack3 to stack4 */}
        <path
          d="M 700, 415 L 700, 430"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack4 to bottom */}
        <path
          d="M 1000, 5 L 1000, 25"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* top to CLD2 */}
        <path
          d="M 1000, 90 L 1000, 105"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* CLD2 to Stack 5 */}
        <path
          d="M 1000, 175 L 1000, 185"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack5 to stack6 */}
        <path
          d="M 1000, 255 L 1000, 265"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack6 to stack7 */}
        <path
          d="M 1000, 335 L 1000, 345"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack7 to stack8 */}
        <path
          d="M 1000, 415 L 1000, 430"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack8 to bottom */}
        <path
          d="M 1300, 5 L 1300, 25"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* top to CLD3 */}
        <path
          d="M 1300, 90 L 1300, 105"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* CLD3 to Stack 9 */}
        <path
          d="M 1300, 175 L 1300, 185"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack9 to stack10 */}
        <path
          d="M 1300, 255 L 1300, 265"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack10 to stack11 */}
        <path
          d="M 1300, 335 L 1300, 345"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack11 to stack12 */}
        <path
          d="M 1300, 415 L 1300, 430"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* stack12 to bottom */}
        <path
          d="M 700, 430 L 1300, 430"
          stroke="white"
          strokeWidth={1}
          fill="none"
        />{" "}
        {/* bottom */}
        {/*<foreignObject x={620} y={35} width={140} height={90}>*/}
        {/*    <div style={data[275120] === 0 ? styles.CLDOpenStyle : styles.CLDCloseStyle}>*/}
        {/*            {gridCLD(275120)} /!** CLD001 *!/*/}
        {/*    </div>*/}
        {/*</foreignObject>*/}
        {/*<foreignObject x={920} y={35} width={140} height={90}>*/}
        {/*    <div style={data[275160] === 0 ? styles.CLDOpenStyle : styles.CLDCloseStyle}>*/}
        {/*            {gridCLD(275160)} /!** CLD002 *!/*/}
        {/*    </div>*/}
        {/*</foreignObject>*/}
        {/*<foreignObject x={1220} y={35} width={140} height={90}>*/}
        {/*    <div style={data[275200] === 0 ? styles.CLDOpenStyle : styles.CLDCloseStyle}>*/}
        {/*            {gridCLD(275200)} /!** CLD003 *!/*/}
        {/*    </div>*/}
        {/*</foreignObject>*/}
      </svg>

      {/* IDC, IDC Value */}
      <Grid columns="equal" divided inverted padded>
        {/** //! map함수 사용해서 구현하는 것으로 변경, hmi_display_name, hmi_display_subgroup 설정 필요함 */}
        <Grid.Row
          textAlign="center"
          style={{ marginRight: "300px", marginLeft: "300px" }}
        >
          <Grid.Column>
            <Segment color="#262626" inverted>
              <h4>IDC 1</h4>
              {data[13314]} {/* CP_IDC1 */}
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment color="#262626" inverted>
              <h4>IDC 2</h4>
              {data[13315]} {/* CP_IDC2 */}
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment color="#262626" inverted>
              <h4>IDC 3</h4>
              {data[13316]} {/* CP_IDC3 */}
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {/* //! 외부 Component로 구성?  */}
      <Grid
        columns="equal"
        divided
        style={{ width: "1000px", marginTop: "0px" }}
      >
        <Grid.Row>
          <Grid.Column style={styles.name_2}>TEMP</Grid.Column>
          <Grid.Column style={styles.name_2}>VDC</Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid style={{ marginTop: "0px" }}>
        <Grid.Row>
          <Grid columns={2} divided celled style={{ width: "500px" }}>
            <Grid.Row>
              <Grid.Column style={styles.name_2}>
                <Grid.Row style={{ color: "yellow" }}>Min Temp</Grid.Row>
                <Grid.Row style={styles.gridValue}>
                  {" "}
                  {getDisplayMinValue(tempObj)}
                </Grid.Row>
                <Grid.Row style={{ color: "#FF335B" }}>
                  {" "}
                  {minTemp.current} ℃{" "}
                </Grid.Row>
              </Grid.Column>
              <Grid.Column style={styles.name_2}>
                <Grid.Row style={{ color: "yellow" }}>Max Temp</Grid.Row>
                <Grid.Row style={styles.gridValue}>
                  {" "}
                  {getDisplayMaxValue(tempObj)}{" "}
                </Grid.Row>
                <Grid.Row style={{ color: "#1EDA6B" }}>
                  {" "}
                  {maxTemp.current} ℃
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <Grid columns={2} divided celled style={{ width: "500px" }}>
            <Grid.Row>
              <Grid.Column style={styles.name_2}>
                <Grid.Row style={{ color: "yellow" }}>Min Voltage</Grid.Row>
                <Grid.Row style={styles.gridValue}>
                  {" "}
                  {getDisplayMinValue(voltObj)}{" "}
                </Grid.Row>
                <Grid.Row style={{ color: "#FF335B" }}>
                  {" "}
                  {minVolt.current} V
                </Grid.Row>
              </Grid.Column>
              <Grid.Column style={styles.name_2}>
                <Grid.Row style={{ color: "yellow" }}>Max Voltage</Grid.Row>
                <Grid.Row style={styles.gridValue}>
                  {" "}
                  {getDisplayMaxValue(voltObj)}{" "}
                </Grid.Row>
                <Grid.Row style={{ color: "#1EDA6B" }}>
                  {" "}
                  {maxVolt.current} V
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Row>
      </Grid>

      <Footer tags={FooterTags} data={data} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "25px",
  },
  row: {
    padding: "2px 0",
  },
  name: {
    fontSize: "18px",
    fontWeight: "500",
    marginLeft: "10px",
  },
  name_2: {
    fontWeight: "bold",
    textAlign: "center",
  },
  gridValue: {
    textAlign: "center",
    fontWeight: "500",
  },
  minValue: {
    textAlign: "center",
    fontWeight: "500",
    fontColor: "#FF3355",
  },
  maxValue: {
    textAlign: "center",
    fontWeight: "500",
    fontColor: "#08F856",
  },
  CLDOpenStyle: {
    height: "100%",
    color: "green",
    fontWeight: "bold",
  },
  CLDCloseStyle: {
    height: "100%",
    color: "red",
    fontWeight: "bold",
  },
};

export default StackOvr_S300_PSM2;
